import React from 'react';
import './styles.css';

const Title= ({text}) => {
    return <h2 className="title-block"> {text} </h2>;
}

export default Title;